<div class="modal-header">
  <h5 class="modal-title" id="modal-title">{{configObj?.data?.title}}</h5>
  <span class="close" aria-describedby="modal-title" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </span>
</div>
<div class="modal-body">
  <div class="browse-file-container">
    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
      (onFileLeave)="fileLeave($event)">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="drag-drop-container">
          <div class="xlsx-img">
            <img class="csv-svg"
              [src]="(configObj?.isMultiUpload) ? '../../../../../assets/images/upload-image.svg' : '../../../../../assets/images/csv.svg'">
            </div>
            Drag and drop files here <br> or
          </div>
          <div class="text-center">
            <button type="button" (click)="openFileSelector()" class="popup-button text-upper">
              Browse Files
            </button>
          </div>
        </ng-template>
      </ngx-file-drop>
      <!-- [class.multiple-uploaded-file-table]="configObj?.isMultiUpload" -->
      <div class="upload-table uploaded-file-table">
        <table class="table">
          @if (!configObj?.isMultiUpload) {
            <tbody class="upload-name-style">
              @for (item of files; track item; let i = $index) {
                <tr>
                  <td class="table-data">
                    <img src="../../../../../assets/images/csv.svg" class="csv-svg">&nbsp;&nbsp;
                    <strong class="uploaded-file-name">{{ item.relativePath }}{{item.size}}</strong>
                    <img src="../../../../../assets/images/file-tick.png" class="file-tick">
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (configObj?.isMultiUpload && fileData.length > 0) {
            <tbody class="upload-name-style">
              @for (item of fileData; track item; let i = $index) {
                <tr>
                  <td class="table-data">
                    @if (item.preview_data) {
                      <img [src]="item.preview_data" width="50" height="50"
                        class="csv-svg">
                      }&nbsp;&nbsp; <strong class="uploaded-file-name">
                    {{item.name}}</strong>
                    <div class="delete-container">
                      <i class="pi pi-trash delete-icon" (click)="openConfirmPopup(true,i)"></i>
                    </div>
                    <img src="../../../../../assets/images/file-tick.png" class="file-tick">
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>

    </div>
    <div class="text-center mt-3">
      <button (click)="upload()" class="popup-button gms-btn"
        [disabled]="(configObj?.isMultiUpload ? fileData.length == 0 : (files.length == 0)||configObj.UploadDisabled) "
      [ngClass]="configObj?.isMultiUpload ? (fileData.length == 0 ? 'no-drop' : '') : (files.length == 0 ? 'no-drop' : '')">Upload</button>
    </div>
    <div id="fUploagMsg" class="text-success">{{fileMsg}}</div>
  </div>